export { default as ReceiptDetails } from './receipt-details';
